import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, object=auth
  const [error, setError] = useState("");

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("df_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("df_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = async (identifier, password, tenant_slug = null) => {
    setError("");
    try {
      // Acepta usuario o correo: detectar por presencia de @ para mejorar mensajes de servidor.
      const looksLikeEmail = typeof identifier === "string" && identifier.includes("@");
      const payload = looksLikeEmail
        ? { email: identifier, password, tenant_slug }
        : { username: identifier, password, tenant_slug };
      const { data } = await api.post("/auth/login", payload);
      if (data.access_token) localStorage.setItem("df_token", data.access_token);
      if (data.tenant_slug) localStorage.setItem("df_tenant", data.tenant_slug);
      setUser(data.user);
      return true;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const register = async (payload) => {
    setError("");
    try {
      const { data } = await api.post("/auth/register", payload);
      if (data.access_token) localStorage.setItem("df_token", data.access_token);
      setUser(data.user);
      return true;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* noop */ }
    localStorage.removeItem("df_token");
    localStorage.removeItem("df_tenant");
    setUser(false);
    // Notificar al BrandingProvider para que limpie favicon/colores del tenant anterior
    try { window.dispatchEvent(new Event("dc:logout")); } catch { /* noop */ }
  };

  return (
    <AuthContext.Provider value={{ user, error, login, register, logout, refresh: bootstrap }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
